import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './modalService.css';

import ArrowLeft from '../../assets/images/majesticons/arrow-left.svg';
import ArrowRight from '../../assets/images/majesticons/arrow-right.svg';
import { colors } from '@mui/material';

const ModalBody = (props) => {
  const { item, handleMoveLeft, handleMoveRight } = props

  return (
    <div className="body-container">
      <div className="body-fitcontents">
        <Button
          variant="secondary"
          className="body-fitcontents-button-icon"
          onClick={handleMoveLeft}
        >
          <img className="body-fitcontents-icon" src={ArrowLeft} alt="left"/>
        </Button>
      </div>
      <div>
        <div className="body-title">
          <img className="body-title-icon" src={item.number} alt="icon service"/>
          <div className="body-title-text">{item.title}</div>
        </div>
        <div dangerouslySetInnerHTML={{ __html: item.longdescription }} />
      </div>
      <div className="body-fitcontents">
        <Button
          variant="secondary"
          className="body-fitcontents-button-icon"
          onClick={handleMoveRight}
        >
          <img className="body-fitcontents-icon" src={ArrowRight} alt="right"/>
        </Button>
      </div>
    </div>
  )
}

const ModalService = (props) => {
  const { item, index, services, show, setShow } = props
  const [itemFromServices, setItemFromServices] = useState(null)
  const [indexMove, setIndexMove] = useState(null)

  const handleClose = () => {
    setItemFromServices(null)
    setIndexMove(null)
    setShow(false)
  }

  const handleMoveLeft = () => {
    const pickedIndex = indexMove == null ? index : indexMove

    if (pickedIndex - 1 < 0) {
      setIndexMove(services.length - 1)
      setItemFromServices(services[services.length - 1])
    } else {
      setIndexMove(pickedIndex - 1)
      setItemFromServices(services[pickedIndex - 1])
    }
  }

  const handleMoveRight = () => {
    const pickedIndex = indexMove == null ? index : indexMove
    if (pickedIndex + 1 > services.length - 1) {
      setIndexMove(0)
      setItemFromServices(services[0])
    } else {
      setIndexMove(pickedIndex + 1)
      setItemFromServices(services[pickedIndex + 1])
    }
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className="special_modal"
        size="xl"
      >
        <Modal.Header>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="modal-button-close"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <ModalBody
            item={itemFromServices || item}
            handleMoveLeft={handleMoveLeft}
            handleMoveRight={handleMoveRight}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="center">
            <Button
              variant="secondary"
              className="modal-button-contact"
              onClick={() => {
                handleClose();
                const contactSection = document.getElementById('contact-section');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              <b id="serviceModalContact">Contact Us</b>
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ModalService

